import axios from 'axios';

export default {
  getTourIdx (idx, nationIdx) {
    return new Promise((resolve, reject) => {
      axios.get(`/v5/tour/${idx}`, {params: {
        nation_idx: nationIdx
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getTourIdxNations (idx) {
    return new Promise((resolve, reject) => {
      axios.get(`/v5/tour/${idx}/nation`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getTourIdxMenuIdx (tourIdx, menuIdx, page, second, nationIdx, keyword) {
    return new Promise((resolve, reject) => {
      axios.get(`/v5/tour/${tourIdx}/menu/${menuIdx}`, {params: {
        time: second,
        page,
        count: 20,
        nation_idx: nationIdx,
        keyword,
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  }
}
